import React, { useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import { UiComponent } from 'components';
import * as M from 'styles/mobile';
import useDetail from '../useDetail';
import PreviewModal from '../Detail/PreviewModal';
import useParticipantCount from '../useParticipantCount';
import Actions from './Actions';
import EditSheet from './EditSheet';
import { getEventStatus, getEventStatusTone } from '../utils';
import * as S from './style';

const DATE_FORMAT = 'YYYY.MM.DD HH:mm';

const formatRange = (start: string, end: string) =>
  `${dayjs(start).format(DATE_FORMAT)} ~ ${dayjs(end).format(DATE_FORMAT)}`;

function Info() {
  const { event } = useDetail();
  const participantCount = useParticipantCount(event);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenPreview, setIsOpenPreview] = useState(false);

  if (!event) return null;

  const status = getEventStatus(
    event.eventStatus,
    event.startDate,
    event.endDate,
    event.enrollStartDate,
    event.enrollEndDate,
  );

  const rows: [string, string][] = [
    ['모집기간', formatRange(event.enrollStartDate, event.enrollEndDate)],
    ['일시', formatRange(event.startDate, event.endDate)],
    ['장소', event.locationName || '-'],
    ['모집인원', participantCount || '-'],
    ['인증기관', event.certificationAgency?.join(', ') || '-'],
    ['봉사시간', `${Number(event.volunteerHours || 0)}시간`],
  ];

  return (
    <>
      <div css={M.card}>
        <div css={S.top}>
          {event.mainImageUrl && (
            <img src={event.mainImageUrl} alt="썸네일" css={S.thumbnail} />
          )}
          <div css={S.summary}>
            <span css={[M.tag(getEventStatusTone(status)), S.tag]}>
              {status}
            </span>
            <p css={S.title}>{event.title}</p>
            <p css={S.startDate}>
              {dayjs(event.startDate).locale('ko').format('MM.DD(dd) A hh:mm')}
            </p>
            <p css={S.organization}>{event.organizationName}</p>
          </div>
        </div>
        <div css={M.cardHeader}>
          기본정보
          {event.eventStatus !== 'CANCELLED' && (
            <button
              type="button"
              css={M.textButton}
              onClick={() => setIsOpenEdit(true)}
            >
              수정
            </button>
          )}
        </div>
        <dl css={M.infoList}>
          {rows.map(([label, value]) => (
            <div key={label} css={M.infoRow}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </div>
      <UiComponent.Button
        variant="border"
        color="grey"
        css={S.previewButton}
        onClick={() => setIsOpenPreview(true)}
      >
        앱 미리보기
      </UiComponent.Button>
      <Actions event={event} />
      {isOpenPreview && (
        <PreviewModal event={event} onClose={() => setIsOpenPreview(false)} />
      )}
      {isOpenEdit && (
        <EditSheet event={event} onClose={() => setIsOpenEdit(false)} />
      )}
    </>
  );
}

export default Info;
